const path = 'notifications/notifications/'

const list = ({ opt = {} }) => axios.get(path, opt)
const create = ({ form, opt = {} }) => axios.post(path, form, opt)
const edit = ({ pk, form, opt = {} }) => axios.put(`${path}${pk}/`, form, opt)
const show = ({ pk, opt = {} }) => axios.get(`${path}${pk}/`, opt)
const remove = ({ pk }) => axios.delete(`${path}${pk}/`)
const byUser = ({ pk, opt = {} }) => axios.get(`${path}${pk}/by-user`, opt)

const setting_path = 'notifications/settings/'
const setting = {
  list: ({ opt = {} }) => axios.get(setting_path, opt),
  create: ({ form, opt = {} }) => axios.post(setting_path, form, opt),
  edit: ({ pk, form, opt = {} }) =>
    axios.put(`${setting_path}${pk}/`, form, opt),
  show: ({ pk, opt = {} }) => axios.get(`${setting_path}${pk}/`, opt),
  remove: ({ pk }) => axios.delete(`${setting_path}${pk}/`),
  byUser: ({ opt = {} }) => axios.get(setting_path, opt)
}

export default { list, create, edit, show, remove, byUser, setting }
